import { __assign } from "tslib";
import { composer } from '../../../../../component-decorators/composer';
import s from '../solution-rate-reviews.scss';
import React from 'react';
import StarFilled from 'wix-ui-icons-common/StarFilled';
import { RateCharts } from './solution-rate-charts';
import { Heading, Box, Text } from 'wix-style-react';
export var dtoToSolutionRateProps = function (reviewsDto) {
    return {
        ratingHistogram: reviewsDto.body.ratingHistogram,
        reviewStars: reviewsDto.body.averageRating,
        numberOfReviews: reviewsDto.body.totalReviews,
    };
};
export var SolutionRate = composer()
    .withTranslation()
    .compose(function (props) {
    var _a;
    return (React.createElement("div", { className: s.solutionRatingCotainer },
        React.createElement("div", { className: s.rateTitle },
            React.createElement("div", null,
                React.createElement(Box, { direction: "horizontal", className: s.ratingMainTitle, verticalAlign: "middle" },
                    React.createElement(StarFilled, { size: "28", color: "#FDB10C" }),
                    React.createElement(Heading, { className: s.avgRating, appearance: "H2", dataHook: "solution-average-rating" }, props.t('solution.page.avgRating', {
                        rating: (_a = props.reviewStars) === null || _a === void 0 ? void 0 : _a.toFixed(1),
                    }))),
                React.createElement(Box, { marginTop: '6px', marginLeft: '24px' },
                    React.createElement(Text, { size: 'medium', weight: 'thin', secondary: true, dataHook: "solution-based-on-reviews" }, props.t('solution.page.basedOn', {
                        rateCount: props.numberOfReviews,
                    }))))),
        React.createElement("div", { className: s.rateMeter },
            React.createElement(RateCharts, __assign({ totalCount: props.numberOfReviews }, props.ratingHistogram)))));
});
//# sourceMappingURL=solution-rate.js.map